<template>
  <div>
    <v-dialog v-if="dialog" v-model="dialog" max-width="40vw" persistent>
      <v-card>
        <v-card-title class="primary">
          <span class="headline white--text">Edit RatePlan</span>
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="observer" v-slot="{ validate, reset }">
            <v-form v-model="valid" lazyValidation>
              <v-container grid-list-md>
                <v-layout row wrap class="px-0">
                  <v-flex xs12 md4>
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="ratePlainID"
                      rules="required|min_value:1"
                    >
                      <v-text-field
                        name="ratePlanID"
                        v-model="editedItem.ratePlanID"
                        label="Rate Plan ID"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 md8>
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="ratePlanDescription"
                      rules="required"
                    >
                      <v-text-field
                        v-model="editedItem.ratePlanDescription"
                        label="Rate Plan Description"
                        name="ratePlanDescription"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 md6>
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="groupName"
                    >
                      <v-text-field
                        v-model="editedItem.groupName"
                        label="Group Name"
                        name="groupName"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 md6>
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="usageType"
                      rules="required"
                    >
                      <v-select
                        data-vv-as="usageType"
                        name="usageType"
                        v-model="editedItem.usageType"
                        label="Usage Type"
                        :items="usageType"
                        :error-messages="errors"
                      ></v-select>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 md6>
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="dataAllowance"
                      rules="required"
                    >
                      <v-text-field
                        v-model="editedItem.dataAllowance"
                        label="Data Allowance"
                        name="dataAllowance"
                        :error-messages="errors"
                        type="number"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-checkbox
                      name="monitorDataUsage"
                      v-model="editedItem.monitorDataUsage"
                      label="Monitor Data Usage"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </ValidationObserver>
          <message-alert :component="message"></message-alert>
        </v-card-text>
        <v-card-actions class="pb-4 pr-4 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="save">Save</v-btn>
          <v-btn color="light-grey" @click.native="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs4>
        <v-text-field
          name="Search"
          label="Search"
          v-model="SearchText"
          append-icon="search"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        
        <ag-grid-vue
          :style="{ width, height }"
          domLayout="autoHeight"
          class="ag-theme-balham mb-4"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="rows"
          pagination
          :paginationPageSize="10"
          :frameworkComponents="frameworkComponents"
          @grid-ready="onFirstDataRendered"
        ></ag-grid-vue>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { AgGridVue } from 'ag-grid-vue';
import TableButtons from '@/components/wholesaler/table-buttons';

const {
  mapActions: mapRatePlanActions,
  mapMutations: mapRatePlanMutations,
} = createNamespacedHelpers(`orders/ratePlan`);
import {
  mapRatePlanFields,
  mapRatePlanMultiRowFields,
} from '../../store/modules/orders';
import { ratePlan } from '../../models/ratePlan.js';
import compact from 'lodash/compact';
export default {
  name: "Rateplan",
  components: {
    AgGridVue,
    TableButtons
  },
  data: () => ({
    archived: false,
    valid: true,
    dialog: false,
    editedItem: new ratePlan(),
    editedIndex: 0,
    SearchText: null,
    usageType: [],
    gridOptions: null,
    columnDefs: null,
    defaultColDef: null,
    rowData: null,
    gridApi: null,
    frameworkComponents: null,
    height: '100%',
    width: '100%',
  }),
  computed: {
    ...mapRatePlanFields(['message']),
    ...mapRatePlanMultiRowFields(['rows']),
    filteredRows: function () {
      let vm = this;
      return vm.rows.filter(this.isValid);
    },
  },
  methods: {
    ...mapRatePlanActions([
      'getRatePlans',
      'saveRatePlans',
      'removeRatePlan',
      'saveRatePlan',
      'setMessage',
    ]),
    getDataFromApi() {
      let vm = this;
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.getRatePlans({ filter: null, archived: vm.archived }).then(
          data => {
            let items = data.data;
            const total = data.count;
            vm.usageType = compact(
              Array.from(new Set(vm.rows.map(a => a.usageType)))
            ).map(item => {
              return item !== 'nbnEnterprise'
                ? {
                    text: item,
                    value: item,
                  }
                : {
                    text: 'NBN Enterprise',
                    value: 'nbnEnterprise',
                  };
            });
            if (vm.allFlags.SOG3501)
              vm.usageType.push({
                text: 'Teams',
                value: 'Teams',
              });
            vm.loading = false;
            resolve({
              items,
              total,
            });
          }
        );
      });
    },
    onFirstDataRendered(grid) {
      grid.api.sizeColumnsToFit();
    },
    save() {
      let vm = this;
      vm.$refs.observer.validate().then(result => {
        if (result) {
          this.saveRatePlan(this.editedItem)
            .then(data => {
              this.close();
            })
            .catch(() => {});
        }
      });
    },
    close() {
      this.$refs.observer.reset()
      this.dialog = false;
      this.getDataFromApi()
    },
  },
  watch: {
    SearchText(val) {
      this.gridOptions.api.setQuickFilter(val);
    },
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: '',
        field: 'actions',
        cellRenderer: 'tableButtons',
        cellRendererParams: {
          clicked: function (param) {
            vm.editedItem = param
            vm.dialog = true
          },
        },
        width: 100
      },
      {
        headerName: 'Rate Plan ID',
        field: 'ratePlanID',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Rate Plan Description',
        field: 'ratePlanDescription',
        sortable: true,
        filter: true,
        width: 350,
        sort: 'asc'
      },
      {
        headerName: 'Group Name',
        field: 'groupName',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Usage Type',
        field: 'usageType',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Data Allowance',
        field: 'dataAllowance',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Monitor Data Usage',
        field: 'monitorDataUsage',
        sortable: true,
        filter: true,
        cellRenderer: function(params) {
          var input = document.createElement('input');
          input.type = 'checkbox';
          input.checked = params.value;
          return input;
        },
      },
    ];
    
    vm.frameworkComponents = {
      tableButtons: TableButtons,
    };

    vm.defaultColDef = {
      autoHeight: true,
    };
  },
  async mounted() {
    let vm = this;
    await vm.getDataFromApi();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
